import { Button, Skeleton } from '@longy/web-components'
import { createFileRoute, Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { CatalogCard, CatalogPage } from '../../components/catalog/CatalogPage'
import { api } from '../../core/trpc'
import { useLocale } from '../../hooks/useLocale'
import { formatPrice } from '../../utils/formatPrice'

const PATH = '/care-examinations/'

const CareExaminationsPage = () => {
    const { t } = useTranslation()
    const { getLocalizedValue } = useLocale()

    const { data: services, isPending } = api.careExamination.getPublicServices.useQuery({})

    return (
        <CatalogPage
            title={t('frontend.catalog.careExaminationsTitle')}
            lead={t('frontend.catalog.careExaminationsLead')}
        >
            {isPending ? (
                <Skeleton className="h-64 w-full" />
            ) : !services?.length ? (
                <p className="text-brand-gray">{t('frontend.catalog.nothingAvailable')}</p>
            ) : (
                <ul className="grid gap-4 sm:grid-cols-2">
                    {services.map((service) => (
                        <li key={service.id} className="flex">
                            <CatalogCard
                                title={getLocalizedValue(service.name)}
                                subtitle={getLocalizedValue(service.description)}
                                meta={
                                    service.price == null ? undefined : (
                                        <p className="text-sm font-semibold text-primary">
                                            {formatPrice(service.price)}
                                        </p>
                                    )
                                }
                                action={
                                    <div className="flex flex-wrap gap-2">
                                        <Button asChild size="sm">
                                            {/* Into the flow with the service already chosen,
                                                the way mobile's CareSelectService takes a
                                                prefill. */}
                                            <Link
                                                to="/booking/examination"
                                                search={{ serviceId: service.id }}
                                            >
                                                {t('frontend.catalog.bookNow')}
                                            </Link>
                                        </Button>
                                        <Button asChild size="sm" variant="outline">
                                            <Link
                                                to="/care-examinations/$serviceId"
                                                params={{ serviceId: service.id }}
                                            >
                                                {t('frontend.catalog.details')}
                                            </Link>
                                        </Button>
                                    </div>
                                }
                            />
                        </li>
                    ))}
                </ul>
            )}
        </CatalogPage>
    )
}

export const Route = createFileRoute(PATH)({
    head: () => ({ meta: [{ title: 'Long-Y - Járóbeteg-ellátás' }] }),
    loader: async ({ context }) => {
        await context.apiUtils.careExamination.getPublicServices
            .ensureData({})
            .catch(() => undefined)
    },
    component: CareExaminationsPage,
})
